<template>
  <div class="amprod-cart-actions">
    <button class="request-quote-btn" @click="$emit('request-quote')">
      Request Quote
    </button>
  </div>
</template>

<script>
export default {
  name: "CartActions",
  emits: ["continue-shopping", "request-quote"],
};
</script>

<style scoped>
.amprod-cart-actions {
  display: flex;
  gap: 15px;
  justify-content: space-between;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.continue-shopping-btn,
.request-quote-btn {
  padding: 18px 36px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  border: none;
}

.continue-shopping-btn {
  background-color: #6c757d;
  color: white;
}

.continue-shopping-btn:hover {
  background-color: #5a6268;
}

.request-quote-btn {
  background-color: #0073aa;
  color: white;
}

.request-quote-btn:hover {
  background-color: #005a87;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 115, 170, 0.3);
}

/* Responsive design */
@media (max-width: 768px) {
  .amprod-cart-actions {
    flex-direction: column;
  }

  .continue-shopping-btn,
  .request-quote-btn {
    width: 100%;
  }
}
</style>
